/* RiderHouse custom home — rh.js v6 (gsap + ScrollTrigger from CDN, window scroll on home) */
(function () {
  if (window.__rhInit) return; window.__rhInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var booted = false;

  function splitChars(el) {
    if (!el) return [];
    if (el.dataset.rhSplit) return el.querySelectorAll('.rh-ch');
    var t = el.textContent; el.textContent = ''; el.dataset.rhSplit = '1';
    t.trim().split(/\s+/).forEach(function (w, i) {
      if (i) el.appendChild(document.createTextNode(' '));
      var wd = document.createElement('span'); wd.className = 'rh-wd';
      Array.prototype.forEach.call(w, function (c) {
        var s = document.createElement('span'); s.className = 'rh-ch'; s.textContent = c; wd.appendChild(s);
      });
      el.appendChild(wd);
    });
    return el.querySelectorAll('.rh-ch');
  }
  function splitWords(el) {
    if (!el) return [];
    if (el.dataset.rhSplit) return el.querySelectorAll('.rh-w');
    var words = el.textContent.trim().split(/\s+/); el.textContent = ''; el.dataset.rhSplit = '1';
    words.forEach(function (w, i) {
      var s = document.createElement('span'); s.className = 'rh-w'; s.textContent = w;
      el.appendChild(s); if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    return el.querySelectorAll('.rh-w');
  }
  /* wrap each rendered line in a mask so it can rise into view */
  function splitLines(el) {
    if (!el) return [];
    if (el.dataset.rhLines) return el.querySelectorAll('.rh-line > span');
    var parts = el.innerHTML.split(/<br\s*\/?>/i); var nodes = [];
    el.innerHTML = '';
    parts.forEach(function (part, pi) {
      var holder = document.createElement('span'); holder.innerHTML = part; var txt = holder.textContent.trim();
      if (txt) txt.split(/\s+/).forEach(function (w) { var s = document.createElement('span'); s.textContent = w + ' '; s.style.display = 'inline-block'; s.style.whiteSpace = 'pre'; el.appendChild(s); nodes.push(s); });
      if (pi < parts.length - 1) { var br = document.createElement('br'); el.appendChild(br); nodes.push(br); }
    });
    var lines = [], cur = [], top = null;
    nodes.forEach(function (n) {
      if (n.tagName === 'BR') { if (cur.length) lines.push(cur); cur = []; top = null; return; }
      var t = n.offsetTop; if (top !== null && t > top + 2) { lines.push(cur); cur = []; } top = t; cur.push(n.textContent);
    });
    if (cur.length) lines.push(cur);
    el.innerHTML = '';
    lines.forEach(function (l) {
      var o = document.createElement('span'); o.className = 'rh-line'; var i = document.createElement('span');
      i.textContent = l.join('').replace(/\s+$/, ''); o.appendChild(i); el.appendChild(o);
    });
    el.dataset.rhLines = '1';
    return el.querySelectorAll('.rh-line > span');
  }

  function magnetic() {
    if (!fine) return;
    document.querySelectorAll('.rh .rh-btn, .rh .rh-room__go').forEach(function (b) {
      if (b.dataset.rhMag) return; b.dataset.rhMag = '1';
      var xTo = window.gsap.quickTo(b, 'x', { duration: 0.5, ease: 'power3' });
      var yTo = window.gsap.quickTo(b, 'y', { duration: 0.5, ease: 'power3' });
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        xTo((e.clientX - r.left - r.width / 2) * 0.3); yTo((e.clientY - r.top - r.height / 2) * 0.4);
      });
      b.addEventListener('mouseleave', function () { xTo(0); yTo(0); });
    });
  }

  function boot() {
    if (booted || !window.gsap || !window.ScrollTrigger) return;
    booted = true;
    var gsap = window.gsap; var ST = window.ScrollTrigger; gsap.registerPlugin(ST);

    if (reduce) { document.querySelectorAll('.rh-manifesto__text').forEach(splitWords); return; }

    /* Horizon scrolls inside .page-wrapper on wide screens, the window on small ones */
    var pw = document.querySelector('.page-wrapper');
    var scroller = (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) ? pw : window;
    ST.defaults({ scroller: scroller });
    /* Home scrolls with the window on desktop too (see rh.css v6), so Horizon's header,
       which listens to .page-wrapper there, gets the same signals it gets on mobile */
    if (pw && scroller === window && window.matchMedia('(min-width: 990px)').matches) {
      var hc = document.querySelector('header-component[sticky]');
      if (hc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var en = es[es.length - 1]; if (!en) return;
          hc.dataset.stickyState = en.isIntersecting ? 'inactive' : 'active';
        }, { threshold: 1 }).observe(hc);
        var lastY = window.scrollY;
        window.addEventListener('scroll', function () {
          var y = window.scrollY, top = hc.getBoundingClientRect().top;
          hc.dataset.scrollDirection = top >= 0 ? 'none' : (y < lastY ? 'up' : 'down');
          lastY = y;
        }, { passive: true });
      }
    }
    var wide = window.matchMedia('(min-width: 990px)');
    var onWide = function () { location.reload(); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    magnetic();

    /* HERO: wooden slats open, the sign lights up */
    document.querySelectorAll('.rh-hero').forEach(function (hero) {
      var stage = hero.querySelector('.rh-hero__stage');
      if (!hero.querySelector('.rh-hero__grain')) { var g = document.createElement('div'); g.className = 'rh-hero__grain'; g.setAttribute('aria-hidden', 'true'); stage.insertBefore(g, hero.querySelector('.rh-hero__mark')); }
      var slats = hero.querySelectorAll('.rh-hero__slats span');
      var word = hero.querySelector('.rh-hero__word');
      var chars = splitChars(word);
      var photo = hero.querySelector('.rh-hero__photo');
      var lede = splitLines(hero.querySelector('.rh-hero__lede'));
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.from(hero.querySelector('.rh-hero__photo img'), { scale: 1.35, duration: 2.6, ease: 'power2.out' }, 0)
        .to(slats, { scaleY: 0, duration: 1.15, ease: 'power4.inOut', stagger: { each: 0.055, from: 'center' } }, 0.2)
        .from(word, { letterSpacing: '0.02em', marginRight: '-0.02em', duration: 2, ease: 'expo.out' }, 0.65)
        .from(chars, { opacity: 0, yPercent: 40, filter: 'blur(8px)', duration: 0.9, stagger: { each: 0.045, from: 'center' } }, 0.65)
        .from(hero.querySelector('.rh-hero__tag'), { opacity: 0, y: 10, duration: 0.9 }, 1.3)
        .from(lede, { yPercent: 110, duration: 1, stagger: 0.08 }, 1.45)
        .from(hero.querySelectorAll('.rh-hero__actions .rh-btn'), { opacity: 0, y: 20, duration: 0.9, stagger: 0.1 }, 1.6);

      var st = { trigger: hero, start: 'top top', end: 'bottom bottom', scrub: true };
      gsap.to(hero.querySelector('.rh-hero__photo img'), { scale: 1.14, yPercent: 6, ease: 'none', scrollTrigger: st });
      gsap.to(hero.querySelector('.rh-hero__mark'), { yPercent: -70, opacity: 0, filter: 'blur(6px)', ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: '60% bottom', scrub: true } });
      gsap.to(hero.querySelector('.rh-hero__foot'), { y: -40, opacity: 0, ease: 'none', scrollTrigger: { trigger: hero, start: '20% top', end: '70% bottom', scrub: true } });
      gsap.to(hero.querySelector('.rh-hero__shade'), { backgroundColor: 'rgba(28,29,31,.6)', ease: 'none', scrollTrigger: st });

      if (fine && photo) {
        var px = gsap.quickTo(photo, 'x', { duration: 1.2, ease: 'power3' });
        var py = gsap.quickTo(photo, 'y', { duration: 1.2, ease: 'power3' });
        stage.addEventListener('mousemove', function (e) {
          px((e.clientX / window.innerWidth - 0.5) * -28); py((e.clientY / window.innerHeight - 0.5) * -18);
        });
      }
    });

    /* MANIFESTO: words light up as you read */
    document.querySelectorAll('.rh-manifesto').forEach(function (sec) {
      var words = splitWords(sec.querySelector('.rh-manifesto__text'));
      gsap.to(words, { opacity: 1, ease: 'none', stagger: 0.1,
        scrollTrigger: { trigger: sec, start: 'top 70%', end: 'bottom 80%', scrub: true } });
    });

    /* masked headline reveals */
    document.querySelectorAll('.rh-shelf__title, .rh-sell__title, .rh-visit__title').forEach(function (h) {
      var lines = splitLines(h);
      gsap.from(lines, { yPercent: 110, duration: 1.1, ease: 'power4.out', stagger: 0.1, scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    });
    document.querySelectorAll('.rh-sell__text, .rh-sell .rh-btn').forEach(function (el) {
      gsap.from(el, { opacity: 0, y: 24, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });

    /* ROOMS: full-screen rooms slide over each other */
    document.querySelectorAll('.rh-rooms').forEach(function (sec) {
      var pin = sec.querySelector('.rh-rooms__pin');
      var rooms = sec.querySelectorAll('.rh-room');
      var nav = sec.querySelectorAll('.rh-rooms__nav span');
      if (!rooms.length) return;
      rooms.forEach(function (r) { if (!r.querySelector('.rh-room__dim')) { var d = document.createElement('div'); d.className = 'rh-room__dim'; r.appendChild(d); } splitChars(r.querySelector('.rh-room__name')); });
      gsap.set(Array.prototype.slice.call(rooms, 1), { xPercent: 100 }); sec.style.setProperty('--rh-n', rooms.length - 1); sec.classList.add('is-ready');
      var setActive = function (i) { nav.forEach(function (n, k) { n.classList.toggle('is-active', k === i); }); };
      setActive(0);
      var tl = gsap.timeline({ defaults: { ease: 'none' },
        scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.8, invalidateOnRefresh: true,
          onUpdate: function (self) { setActive(Math.min(rooms.length - 1, Math.round(self.progress * (rooms.length - 1)))); } } });
      rooms.forEach(function (room, i) {
        if (i === 0) return;
        var prev = rooms[i - 1]; var at = i - 1;
        var media = room.querySelector('.rh-room__img img, .rh-room__shelf');
        var prevMedia = prev.querySelector('.rh-room__img img, .rh-room__shelf');
        tl.fromTo(room, { xPercent: 100 }, { xPercent: 0, duration: 1 }, at)
          .to(prev, { xPercent: -28, duration: 1 }, at)
          .to(prev.querySelector('.rh-room__dim'), { opacity: 0.75, duration: 1 }, at);
        if (media) tl.fromTo(media, { xPercent: -45 }, { xPercent: 0, duration: 1 }, at);
        if (prevMedia && prevMedia.tagName === 'IMG') tl.to(prevMedia, { scale: 1.08, duration: 1 }, at);
        tl.from(room.querySelectorAll('.rh-room__name .rh-ch'), { yPercent: 100, duration: 0.45, stagger: 0.03 }, at + 0.45)
          .from(room.querySelectorAll('.rh-room__desc, .rh-room__go'), { opacity: 0, y: 20, duration: 0.3 }, at + 0.65);
      });
      /* first room: open like the hero */
      var first = rooms[0];
      gsap.from(first.querySelectorAll('.rh-room__name .rh-ch'), { yPercent: 100, duration: 1, ease: 'power4.out', stagger: 0.04, scrollTrigger: { trigger: sec, start: 'top 60%', once: true } });
      var fm = first.querySelector('.rh-room__img, .rh-room__shelf');
      if (fm) gsap.from(fm, { scale: 1.15, duration: 1.6, ease: 'power3.out', scrollTrigger: { trigger: sec, start: 'top 80%', once: true } });
    });

    /* VELOCITY BAND: drifts on its own, speeds up and leans with your scroll */
    document.querySelectorAll('.rh-band').forEach(function (band) {
      var rows = band.querySelectorAll('.rh-band__row');
      var loops = [];
      rows.forEach(function (row, i) {
        var items = row.innerHTML; row.innerHTML = items + items + items + items;
        var dir = i % 2 ? 1 : -1;
        var w = row.scrollWidth / 4;
        var x = dir > 0 ? -w : 0;
        loops.push({ row: row, dir: dir, w: w, x: x });
      });
      var boost = 0, skew = 0;
      ST.create({ trigger: band, start: 'top bottom', end: 'bottom top', onUpdate: function (self) { var v = self.getVelocity(); boost = Math.min(Math.abs(v) / 120, 14); skew = gsap.utils.clamp(-8, 8, v / -300); } });
      gsap.ticker.add(function () {
        loops.forEach(function (l) {
          l.x += l.dir * (0.6 + boost);
          if (l.x <= -l.w) l.x += l.w; if (l.x >= 0) l.x -= l.w;
          l.row.style.transform = 'translate3d(' + l.x + 'px,0,0) skewX(' + skew.toFixed(2) + 'deg)';
        });
        boost *= 0.92; skew *= 0.9;
      });
    });

    /* SHELF: cards open like shutters, one after another */
    document.querySelectorAll('.rh-shelf').forEach(function (sec) {
      var grid = sec.querySelector('.rh-shelf__grid');
      gsap.from(sec.querySelectorAll('.rh-card__img'), { clipPath: 'inset(100% 0% 0% 0%)', duration: 1.2, ease: 'power4.inOut', stagger: 0.12, scrollTrigger: { trigger: grid, start: 'top 88%', once: true } });
      gsap.from(sec.querySelectorAll('.rh-card__name, .rh-card__price'), { opacity: 0, y: 14, duration: 0.8, ease: 'power3.out', stagger: 0.06, delay: 0.5, scrollTrigger: { trigger: grid, start: 'top 88%', once: true } });
    });

    /* SELL: slow parallax behind the headline */
    document.querySelectorAll('.rh-sell').forEach(function (sec) {
      var bg = sec.querySelector('.rh-sell__bg');
      if (bg) gsap.fromTo(bg, { yPercent: -10, scale: 1.08 }, { yPercent: 10, scale: 1, ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* VISIT: the big wordmark rises letter by letter */
    document.querySelectorAll('.rh-visit__word').forEach(function (w) {
      var chars = splitChars(w);
      gsap.from(chars, { yPercent: 105, ease: 'none', stagger: 0.06, scrollTrigger: { trigger: w, start: 'top 98%', end: 'bottom 85%', scrub: true } });
    });

    window.addEventListener('load', function () { ST.refresh(); });
    setTimeout(function () { ST.refresh(); }, 1200);
  }

  function load(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
  function start() {
    var cdn = 'https://cdn.jsdelivr.net/npm/';
    var p = window.gsap ? Promise.resolve() : load(cdn + 'gsap@3.15.0/dist/gsap.min.js');
    p.then(function () { return window.ScrollTrigger ? null : load(cdn + 'gsap@3.15.0/dist/ScrollTrigger.min.js'); })
     .then(boot).catch(function () { document.documentElement.classList.add('rh-nojs'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { booted = false; boot(); window.ScrollTrigger && window.ScrollTrigger.refresh(); });
})();
